import messagePluginsKdialogJsJson from './message/plugins/kdialog.js.json'
import messageUtilsErrorJsJson from './message/utils/error.js.json'
import messageComponentsVideojsIndexJsJson from './message/components/videojs/index.js.json'
import messageComponentsForbidPageLogicIndexTsJson from './message/components/ForbidPage/logic/index.ts.json'
import messageComponentsIllegalAppealLogicIndexTsJson from './message/components/illegalAppeal/logic/index.ts.json'
import messageComponentsVideoPlayerSrcVideoPlayerMobileVueJson from './message/components/VideoPlayer/src/VideoPlayerMobile.vue.json'
import messageComponentsLoadingBoxSrcLoadingBoxVueJson from './message/components/LoadingBox/src/LoadingBox.vue.json'
import messageComponentsLoadingBoxSrcLoadingBoxMobileVueJson from './message/components/LoadingBox/src/LoadingBoxMobile.vue.json'
import messageComponentsTopBarSrcTopBarDefaultVueJson from './message/components/TopBar/src/TopBarDefault.vue.json'
import messageComponentsTopBarSrcTopBarBackMobileVueJson from './message/components/TopBar/src/TopBarBackMobile.vue.json'
import messageComponentsMobileToastToastVueJson from './message/components/MobileToast/toast.vue.json'
import messageComponentsQRCodeSrcQRCodeVueJson from './message/components/QRCode/src/QRCode.vue.json'
import messageComponentsTopBarSrcTopBarVueJson from './message/components/TopBar/src/TopBar.vue.json'
import messageComponentsTopBarMenuSrcTopBarMenuVueJson from './message/components/TopBarMenu/src/TopBarMenu.vue.json'
import messageComponentsTopBarMenuSrcDropDownMenuVueJson from './message/components/TopBarMenu/src/DropDownMenu.vue.json'
import messageComponentsVideoPlayerSrcVideoPlayerVueJson from './message/components/VideoPlayer/src/VideoPlayer.vue.json'
import messageComponentsTopBarSrcNewTopBarVueJson from './message/components/TopBar/src/NewTopBar.vue.json'
import messageComponentsTopBarSrcTopBarMobileVueJson from './message/components/TopBar/src/TopBarMobile.vue.json'
import messageComponentsErrorPageSrcErrorPageVueJson from './message/components/ErrorPage/src/ErrorPage.vue.json'
import messageComponentsIllegalAppealSrcAppealPageMobileVueJson from './message/components/illegalAppeal/src/appealPageMobile.vue.json'
import messageComponentsIllegalAppealSrcAppealDialogVueJson from './message/components/illegalAppeal/src/appealDialog.vue.json'
import messagePagesMobileAppVueJson from './message/pages/mobile/App.vue.json'
import messagePagesIndexAppVueJson from './message/pages/index/App.vue.json'
import messageComponentsDialogSrcContactDialogVueJson from './message/components/Dialog/src/ContactDialog.vue.json'
import messageComponentsTooTipsSrcTooTipsVueJson from './message/components/TooTips/src/TopTips.vue.json'
import incrementJsJson from './message/ui18t.increment.json'

export default {
  ...incrementJsJson,
  ...messagePluginsKdialogJsJson,
  ...messageUtilsErrorJsJson,
  ...messageComponentsVideojsIndexJsJson,
  ...messageComponentsForbidPageLogicIndexTsJson,
  ...messageComponentsIllegalAppealLogicIndexTsJson,
  ...messageComponentsVideoPlayerSrcVideoPlayerMobileVueJson,
  ...messageComponentsLoadingBoxSrcLoadingBoxVueJson,
  ...messageComponentsLoadingBoxSrcLoadingBoxMobileVueJson,
  ...messageComponentsTopBarSrcTopBarDefaultVueJson,
  ...messageComponentsTopBarSrcTopBarBackMobileVueJson,
  ...messageComponentsMobileToastToastVueJson,
  ...messageComponentsQRCodeSrcQRCodeVueJson,
  ...messageComponentsTopBarSrcTopBarVueJson,
  ...messageComponentsTopBarMenuSrcTopBarMenuVueJson,
  ...messageComponentsTopBarMenuSrcDropDownMenuVueJson,
  ...messageComponentsVideoPlayerSrcVideoPlayerVueJson,
  ...messageComponentsTopBarSrcNewTopBarVueJson,
  ...messageComponentsTopBarSrcTopBarMobileVueJson,
  ...messageComponentsErrorPageSrcErrorPageVueJson,
  ...messageComponentsIllegalAppealSrcAppealPageMobileVueJson,
  ...messageComponentsIllegalAppealSrcAppealDialogVueJson,
  ...messagePagesMobileAppVueJson,
  ...messagePagesIndexAppVueJson,
  ...messageComponentsDialogSrcContactDialogVueJson,
  ...messageComponentsTooTipsSrcTooTipsVueJson
}
